import Route from '@ember/routing/route';
import { useQuery } from 'glimmer-apollo';
import { inject as service } from '@ember/service';
import { GET_HOME_PAGE } from '../gql/queries/home-page';

export default class AboutRoute extends Route {
  @service head;

  data = useQuery(this, () => [GET_HOME_PAGE]);

  async model() {
    await this.data.promise;
    return this.data.data;
  }

  afterModel() {
    this.head.updateMeta({
      title: 'About - 1vX.gg',
      description: 'Learn more about 1vX.gg - the ultimate gaming community for esports tournaments, player stats, and competitive gaming.',
      ogTitle: 'About - 1vX.gg',
      ogDescription: 'Learn more about 1vX.gg - the ultimate gaming community for esports tournaments, player stats, and competitive gaming.'
    });
  }
}
